import { Component, Input, OnInit } from '@angular/core';

import { Property, PropertySet } from '@mirage-projects/cw-models';
import { DbPcvizService } from '@mirage-projects/cw-pcviz-core';

import { SlideBarComponentData } from '../../slide-bar';
import { PropertyBagService } from '../property-bag.service';

/**
 * This component is responsible to show number property. If property has range, it will show a slider.
 */
@Component({
    selector: 'cw-property-number',
    templateUrl: './property-number.component.html',
    styleUrls: ['./property-number.component.scss'],
    standalone: false,
})
export class PropertyNumberComponent implements OnInit {
    /** This object comes from the core and provides methods to obtain and set the value of the properties */
    @Input() propertySet!: PropertySet;

    /** Input field with the required information for this field type */
    @Input() property!: Property;

    sliderData!: SlideBarComponentData;
    defaultStep = 1;
    internalValue!: number;
    label = '';

    constructor(
        private propertyBagService: PropertyBagService,
        private dbPcvizService: DbPcvizService
    ) {}

    ngOnInit(): void {
        this.label = this.propertyBagService.getCorrectLabel(this.property);
        this.initDefaultStep();

        const range: number[] = this.propertyBagService.getValueRange(this.propertySet, this.property);
        if (range) {
            this.initializeSlider(range);
        }
    }

    onChange(value: number): void {
        this.property.value = value;
        this.propertyBagService.setValueProperty(this.propertySet, this.property);
    }

    hasValueRange(): boolean {
        const range: number[] = this.propertyBagService.getValueRange(this.propertySet, this.property);
        return range?.length > 0;
    }

    private initializeSlider(range: number[]): void {
        if (!range) {
            return;
        }

        const min = range[0];
        const max = range[1];
        const step = range[2] || this.defaultStep;

        this.sliderData = {
            min,
            max,
            step,
            label: this.label ?? undefined,
            isLogarithmic: this.property.logarithmic ?? false,
        };
    }

    private initDefaultStep(): void {
        if (this.property.type === 'FloatField') {
            this.defaultStep = 0.1;
        }
    }

    get value(): number {
        let value = Number(this.propertyBagService.getValueProperty(this.propertySet, this.property));
        if (this.property.convertUnit?.()) {
            value = this.dbPcvizService.getControllerDB('Units').convertToUserUnit(value, this.property.unitType);
        }
        return value;
    }

    set value(value: number) {
        this.internalValue = value;
    }
}
